import React, {useState} from "react";
import {FormRenderProps} from '@progress/kendo-react-form';
import styles from "../../Tab.module.scss";
import {useRouteLoaderData} from "react-router-dom";
import {IConnectedService, ILocation} from "../../../model";
import {useFormOutletContext} from "./LocationInfo";
import LocationDetailsGeneral from "../../../components/location/Details/General/LocationDetailsGeneral";
import {
    LocationConnectedServices
} from "../../../components/location/Details/LocationConectedService/LocationConnectedServices";



const LocationDetailsTab = () => {
    const location = useRouteLoaderData('location-info') as ILocation;
    const {formRenderProps, edit} = useFormOutletContext();
    const [activeInnerTab, setActiveInnerTab] = useState('General');
    const [connectedServices, setConnectedServices] = useState<IConnectedService[]>([]);
    const innerNavLinks = ['General', 'Connected Services',];


    const renderInnerContent = (formRenderProps: FormRenderProps) => {
        switch (activeInnerTab) {
            case 'General':
                return <LocationDetailsGeneral edit={edit}
                                               location={location}
                                               formRenderProps={formRenderProps}/>;
            case 'Connected Services':
                return <LocationConnectedServices edit={edit}
                                                  customerId={location.id}
                                                  onConnectedServicesChange={(connectedServices: IConnectedService[]) => {setConnectedServices(connectedServices)}}
                                                  {...formRenderProps} />
            default:
                return <div>Page detail for {activeInnerTab}</div>;
        }
    };

    return (
        <div className={styles.detailsLayout}>
            <nav className={styles.innerSidebar}>
                <ul>
                    {innerNavLinks.map((tabName) => (
                        <li key={tabName}>
                            <button
                                type={'button'}
                                className={activeInnerTab === tabName ? styles.active : ''}
                                onClick={() => setActiveInnerTab(tabName)}
                            >
                                {tabName}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className={styles.contentWrapper}>
                <h2 style={{fontWeight: 400}}>{activeInnerTab}</h2>
                {renderInnerContent(formRenderProps)}
            </div>
        </div>
    );
}

export default LocationDetailsTab;
